/**
 *  @description :: Feed Category Page within back admin panel
 *  @author :: Wong Shao Le
 */
'use client'
import React, { useState, useEffect, useRef } from "react";
import {Text, Group, Button, TextInput, Card, Stack } from "@mantine/core";
import { showErrorAlert, showSuccessAlert } from "../../helper/alerts";
import { useForm } from '@mantine/form';
import { RowDataFeedCategory } from "./types";
import classes from "../FeedCategoryPage/FeedCategory.module.css";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import Header from "../static/Header";

export function FeedCategoryPage() {
  const axiosPrivate = useAxiosPrivate();
  const [isLoading, setIsLoading] = useState(false);

  const updateCategory = async (data: RowDataFeedCategory) => {
    try {
        setIsLoading(true);
        await axiosPrivate.post("/api/admin/feed/update-category", {
          category_1: data.cat_1,
          category_2: data.cat_2,
          category_3: data.cat_3
        });
        showSuccessAlert("Feed Category Successfully Updated");
    } catch (error: any) {
        showErrorAlert("Something Went Wrong");
        console.error(error);
    } finally {
        setIsLoading(false);
    }
  };
  
  const fetchCategory = async () => {
      try {
        setIsLoading(true);
        const response = await axiosPrivate.get("/api/feed/read-category"); 
        const resDataArr = response.data.data;

        form.setValues({
          cat_1: resDataArr[0].name ?? "",
          cat_2: resDataArr[1].name ?? "",
          cat_3: resDataArr[2].name ?? "",
        });

      } catch (err) {
        console.error("Failed to fetch contact [ERROR]:", err);
      } finally {
        setIsLoading(false);
      }
    };

  /* Validate form input */
  const form = useForm({
      initialValues: {
          cat_1: "",
          cat_2: "",
          cat_3: "",
      },
      validate: {
          cat_1: (value) => null,
          cat_2: (value) => null,
          cat_3: (value) => null,
      },
  });

  useEffect(() => {
    fetchCategory();
  }, []);

  return (
    <div className={classes.feedCategoryPageContainer}>
      <Header title="Feed Category" />
      <Card shadow="sm" radius="md">
        <Stack>
          <Text size="sm" c="dimmed">
            Configure your video feed categories.
          </Text>

          <form onSubmit={form.onSubmit((values) => {updateCategory(values)})}>

            <TextInput className={classes.Text}
              {...form.getInputProps('cat_1')}
              label="Category 1"
              placeholder="Input Category"
              required
            />

            <TextInput className={classes.Text}
              {...form.getInputProps('cat_2')}
              label="Category 2"
              placeholder="Input Category"
              required
              mt="sm"
            />

            <TextInput className={classes.Text}
              {...form.getInputProps('cat_3')}
              label="Category 3"
              placeholder="Input Category"
              required
              my="sm"
            />

            <div style={{
              width: '50%',
              display: 'flex',
              gap: '10px',
            }}>
              <Button onClick={() => fetchCategory()} className={classes.buttonReset} loading={isLoading}>
                Reset
              </Button>
              <Button type="submit" className={classes.buttonSaveChanges} loading={isLoading}>
                Save Changes
              </Button>
            </div>
          </form>
        </Stack>
      </Card>
    </div>
  );
}

export default FeedCategoryPage;
